<template>
    <div class="cs-defaultComponent" >
      <div class="cs-defaultComponent__container" v-if="!steps.isLoading && !steps.isAddToCartSuccess">
        <DefaultHeader :offer="offer" @closeComponent="$emit('closeComponent')"></DefaultHeader>
        <div class="cs-defaultComponent__serviceInfo">
          <div class="cs-defaultComponent__serviceOriginalPriceLabel">{{dictionary.originalPrice}}</div>
          <div class="cs-defaultComponent__serviceOriginalPrice">{{formatPriceToLocale(offer.regularPrice)}} €</div>
          <div class="cs-defaultComponent__serviceDiscountedPriceLabel">{{dictionary.discountedPrice}} <span class="cs-defaultComponent__serviceDiscountPercentage">-{{offer.discountPercentage}}%</span> </div>
          <div class="cs-defaultComponent__serviceDiscountedPrice">{{formatPriceToLocale(offer.discountedPrice)}} €</div>
        </div>
        <div class="cs-defaultComponent__serviceAttention" v-if="offerDictionary.attentionMessage">
          <div class="cs-defaultComponent__serviceAttentionTitle">{{dictionary.attention}}</div>
          <div class="cs-defaultComponent__serviceAttentionMessage">{{offerDictionary.attentionMessage}}</div>
        </div>
        <div class="cs-defaultComponent__fieldLabel cs-inputLabel">
          {{offerDictionary.fieldLabel}}
        </div>
        <div class="cs-defaultComponent__field">
          <div class="cs-fieldErrorMessage" v-if="hasError()">{{getErrorMessage()}}</div>
          <input class="cs-inputTextField" :class="{ 'cs-inputTextField--error': hasError() }" type="text" v-model="formFieldValue" :placeholder="offerDictionary.fieldPlaceholder">
        </div>
        <div class="cs-defaultComponent__CTA cs-formSubmitButton" v-on:click="onCTAButtonClick()">
          {{dictionary.buyNowTheOffer}}
        </div>
        <DefaultServiceFeatures :offer="offer" :dictionary="dictionary"></DefaultServiceFeatures>
      </div>
      <OfferAddedToCart :dictionary="dictionary" :isShown="steps.isAddToCartSuccess" @closeComponent="$emit('closeComponent')"></OfferAddedToCart>
      <LoaderComponent v-if="steps.isLoading" ></LoaderComponent>
    </div>
  </template>
  
  <script>
  import {addToCart} from '@/assets/js/formUtils.js';
  import DefaultHeader from '@/components/DefaultHeader.vue';
  import DefaultServiceFeatures from '@/components/DefaultServiceFeatures.vue';
  import LoaderComponent from '@/components/LoaderComponent.vue';
  import OfferAddedToCart from '@/components/OfferAddedToCart.vue';
  export default {
    name: 'DefaultComponent',
    props: ["offer", "dictionary", 'isDefaultService','injectedError', 'inputFieldValue', 'addToCart' ],
    emits: ["closeComponent", "goToNextStep"],
    data: function(){
      return {
        offerDictionary: {},
        formFieldValue: '',
        isError: {
          value: false,
          message: ''
        },
        steps: {
          isAddToCartSuccess: false,
          isLoading: false
        }
      }
    },
    methods:{
      formatPriceToLocale(price){
        return Number.parseFloat(price.replace(',','.')).toLocaleString('it-IT', {minimumFractionDigits: 2});
      },
      isFormValid(){
        this.formFieldValue = this.formFieldValue.trim();
        this.formFieldValue = this.formFieldValue.replace(' ', '');
        return {
          value: this.formFieldValue.length > 0,
          message: this.offerDictionary.fieldValueIsEmpty
        }
      },
      toggleLoader(){
        this.steps.isLoading = !this.steps.isLoading;
      },
      async onCTAButtonClick(){
        const isFormValid = this.isFormValid();
        if(isFormValid.value){
          this.toggleLoader();
          if(this.isDefaultService){
            await addToCart(this.offer._id, this.formFieldValue).then((response) => {
              if(response.data.err){
                this.toggleLoader();
                this.setErrorMessage(this.dictionary.addToCartError);
              } else {
                this.toggleLoader();
                this.onAddToCartSuccess();
              }
            }).catch(() => {
              this.toggleLoader();
              this.setErrorMessage(this.dictionary.addToCartError);
            });
          } else {
            this.$emit('goToNextStep', this.formFieldValue);
          }
        } else {
          this.setErrorMessage(isFormValid.message);
        }
      },
      onAddToCartSuccess(){
        this.steps.isAddToCartSuccess = true;
      },
      setErrorMessage(message){
        this.isError.value = true;
        this.isError.message = message;
      },
      hasError(){
        return this.isError.value || ( this.injectedError && this.injectedError.value );
      },
      getErrorMessage(){
        return this.isError.message || this.injectedError.message
      }
    },
    mounted: function(){
      this.offerDictionary = JSON.parse(this.offer.serviceFeatures.dictionary.replace('\n', ''));
      if(this.inputFieldValue){
        this.formFieldValue = this.inputFieldValue;
      }
    },
    components: {
      DefaultHeader, DefaultServiceFeatures, OfferAddedToCart, LoaderComponent
    }
  }
  </script>
  
  <style lang="scss" scoped>
  @import '@/assets/scss/form.scss';
  
    .cs-defaultHeader__container {
      padding: 20px 20px 0 20px;
    }
    .cs-defaultComponent__{
      &container{
        background: white;
        border-radius: 25px;
        margin: 0 20px;
        text-align: center;
        max-width: 360px;
        width: 100%;
        overflow: hidden;

        @media screen and (min-width: 768px) {
          max-width: 400px;
        }
      }

      &__field {
        padding: 0 20px;
        &Label{
          padding: 0 20px;
        }
      }
      &service{

        &Info{
          display: grid;
          grid-template-columns: 2fr 1fr;
          font-size: 16px;
          color: #1B6487;
          font-weight: 400;
          padding: 0 20px;
        }

        &OriginalPrice{
          font-size: 18px;
          color: #F15B65;
          text-align: right;
          &Label{
            text-align: left;
          }
        }

        &DiscountPercentage{
          color: #00DAD2;
          font-size: 20px;
        }

        &DiscountedPrice{
          font-size: 22px;
          color: #61CE70;
          text-align: right;
          font-weight: 700;
          &Label{
            color: #1B6487;
            font-weight: 700;
            text-align: left;
          }
        }

        &Attention{
          font-size: 12px;
          padding: 0 20px;
          &Title{
            color: #F15B65;
            font-weight: 700;
          }
          &Message{
            color: #363636;
            font-weight: 400;
          }
        }
      }
    }
  </style>
  